import { gql } from '@apollo/client';

// ============================================================================
// FRAGMENTS
// ============================================================================

export const COMPRA_FRAGMENT = gql`
  fragment CompraFields on Compra {
    id
    codigo
    proveedor_id
    proveedor {
      id
      nombre
      nombre_comercial
    }
    fecha
    fecha_recepcion
    fecha_vencimiento_pago
    subtotal
    iva_total
    descuento_total
    total
    metodo_pago
    referencia_pago
    estado
    estado_pago
    numero_factura_proveedor
    notas
    comprobante_url
    activo
    usuario {
      id
      nombre
      apellido
    }
    detalles {
      id
      item_inventario_id
      item {
        id
        codigo
        nombre
      }
      codigo_item
      nombre_item
      cantidad
      cantidad_recibida
      precio_unitario
      iva_porcentaje
      iva_monto
      descuento
      subtotal
      total
      recibido
      notas
    }
    created_at
  }
`;

export const COMPRA_LIST_FRAGMENT = gql`
  fragment CompraListFields on Compra {
    id
    codigo
    proveedor {
      id
      nombre
      nombre_comercial
    }
    fecha
    subtotal
    iva_total
    total
    estado
    estado_pago
    numero_factura_proveedor
    comprobante_url
    created_at
  }
`;

// ============================================================================
// QUERIES
// ============================================================================

export const GET_COMPRAS = gql`
  ${COMPRA_LIST_FRAGMENT}
  query GetCompras(
    $proveedor_id: Int
    $estado: String
    $estado_pago: String
    $fecha_desde: Date
    $fecha_hasta: Date
    $limit: Int
    $offset: Int
  ) {
    compras(
      proveedor_id: $proveedor_id
      estado: $estado
      estado_pago: $estado_pago
      fecha_desde: $fecha_desde
      fecha_hasta: $fecha_hasta
      limit: $limit
      offset: $offset
    ) {
      compras {
        ...CompraListFields
      }
      total
    }
  }
`;

export const GET_COMPRA = gql`
  ${COMPRA_FRAGMENT}
  query GetCompra($id: Int!) {
    compra(id: $id) {
      ...CompraFields
    }
  }
`;

// ============================================================================
// MUTATIONS
// ============================================================================

export const CREAR_COMPRA = gql`
  ${COMPRA_FRAGMENT}
  mutation CrearCompra($input: CrearCompraInput!) {
    crearCompra(input: $input) {
      ...CompraFields
    }
  }
`;

export const CONFIRMAR_COMPRA = gql`
  ${COMPRA_FRAGMENT}
  mutation ConfirmarCompra($id: Int!) {
    confirmarCompra(id: $id) {
      ...CompraFields
    }
  }
`;

export const RECIBIR_COMPRA = gql`
  ${COMPRA_FRAGMENT}
  mutation RecibirCompra($input: RecibirCompraInput!) {
    recibirCompra(input: $input) {
      ...CompraFields
    }
  }
`;

export const ANULAR_COMPRA = gql`
  ${COMPRA_FRAGMENT}
  mutation AnularCompra($id: Int!, $motivo: String) {
    anularCompra(id: $id, motivo: $motivo) {
      ...CompraFields
    }
  }
`;
